import PropTypes from 'prop-types';
import { event } from '@zillow/universal-analytics';
export var ExposureEvent = function ExposureEvent(exposureEventPayload) {
  event(exposureEventPayload, {
    integrations: {
      gtm: false
    }
  });
};
ExposureEvent.propTypes = {
  // eslint-disable-next-line zillow/react/forbid-prop-types
  exposureEventPayload: PropTypes.object
};
ExposureEvent.defaultProps = {
  exposureEventPayload: {}
};